<div *ngIf="active" class="pane">
  <ng-content></ng-content>
</div>
